import { FC } from 'react';
import { useAtomValue } from 'jotai';
import Nav from '~/components/nav';
import MarkdownNode from '~/components/markdown-node';

import { $UserAgent, $Locale } from '@lemon8/web-app-shared/atom';
import { $LegalEnterTraffic } from 'shared/atoms';
// Old docs
import jp from './docs/jp.md';
import th from './docs/th.md';
import id from './docs/id.md';
import ph from './docs/ph.md';
import vn from './docs/vn.md';
import my from './docs/my.md';
import sg from './docs/sg.md';
import gb from './docs/gb.md';
import us from './docs/us.md';
// New docs (with _new suffix)
import jp_new from './docs/jp_new.md';
import th_new from './docs/th_new.md';
import id_new from './docs/id_new.md';
import vn_new from './docs/vn_new.md';
import my_new from './docs/my_new.md';
import sg_new from './docs/sg_new.md';
import gb_new from './docs/gb_new.md';
import us_new from './docs/us_new.md';
import au_new from './docs/au_new.md';
import nz_new from './docs/nz_new.md';
import ca_new from './docs/ca_new.md';

// Old docMap (used when shouldUpdateLegalContent is false)
const oldDocMap: Record<string, string> = {
  jp,
  th,
  id,
  ph,
  vn,
  my,
  sg,
  gb,
  us,
  ca: us,
  nz: us,
  au: us,
};

// New docMap (used when shouldUpdateLegalContent is true)
const newDocMap: Record<string, string> = {
  jp: jp_new,
  th: th_new,
  id: id_new,
  vn: vn_new,
  my: my_new,
  sg: sg_new,
  gb: gb_new,
  us: us_new,
  au: au_new,
  nz: nz_new,
  ca: ca_new,
};

export const PolicyBody: FC = () => {
  const { isMobile, isInApp } = useAtomValue($UserAgent);
  const { region } = useAtomValue($Locale);
  const { shouldUpdateLegalContent = false } = useAtomValue($LegalEnterTraffic);

  // 当 shouldUpdateLegalContent 为 true 时,使用新的 md 文件（_new 后缀）
  // 否则使用老的 md 文件
  const src = shouldUpdateLegalContent && newDocMap[region] ? newDocMap : oldDocMap;

  return (
    <>
      {!isInApp && <Nav />}
      <MarkdownNode isMobile={isMobile} isInApp={isInApp} src={src} />
    </>
  );
};
